export const resolveVisitTitle = (
  clientName = "",
  serviceName = "Nepriskirta paslauga",
) => {
  return clientName ? `${clientName}\n${serviceName}` : serviceName;
};
